<template>
  <div class="flex items-center mb-4 last:mb-0">
    <div
      class="flex justify-between items-center w-full truncate cursor-pointer"
    >
      <div
        @click="$emit('toggle')"
        class="w-6 flex justify-center cursor-pointer"
      >
        <svg-eye :eye-color="color" :open="visible" />
      </div>
      <div
        v-tooltip.right-start="{
          content: title.length > 20 ? title : '',
          class: 'max-w-xs break-all',
          delay: { show: 700, hide: 0 }
        }"
        class="pl-2 w-full truncate select-none"
      >
        {{ title }}
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import SvgEye from '../icons/SvgEye'

export default defineComponent({
  name: 'SelectedTag',
  props: {
    title: {
      required: true,
      type: String,
      default: 'Untitled'
    },
    color: {
      required: true,
      type: String,
      default: 'blue'
    },
    visible: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  components: {
    SvgEye
  }
})
</script>

<style scoped></style>
